module.exports = __webpack_public_path__ + "static/img/2.5.b20207e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/2.5.jpg
// module id = kLhv
// module chunks = 7